import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SearchForm from '../../default/search/searchForm';
import { ShimmerCategoryItem } from 'react-shimmer-effects';
import NoContentFound from '../../default/not-found/notFound';
import { DeleteCardAction, retrieveCardsAction } from '../model/cardActions';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ShimmerImage from '../../default/popup/shimmerImage/shimmerImage';
import { InitialAvatar } from '../../default/utils/defaultAvatar';
import DataModelPopup from '../../default/popup/dataModel/contentModelPopup';
import SingleCardData from '../single/singleCardData';

const CardListData = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [loading, setLoading] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const prevSearchTermRef = useRef();
    const [pageCount, setPageCount] = useState(1);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [canShare, setCanShare] = useState(true);
    const [openDataPopup, setDataPopup] = useState(false);
    const [dataPopupId, setDataPopupId] = useState('');

    const handleCloseModal = () => {
        setDataPopup(false);
    };
    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => {
            return prevIndex === index ? null : index;
        });
    };
    const navigate = useNavigate();
    const handleSinglePage = () => {
        navigate('/card-update');
    }
    //out side click for dropdown
    const handleOutsideClick = (event) => {
        if (!event.target.closest('.list-edit-dropdown') && 
            !event.target.closest('.dropdown-toggle-btn')) {
            setOpenDropdown(null);
         }
    };
    // Card data popup
    const handleDataPopup = (e, dataId) => {
        e.preventDefault();
        setDataPopup(false);
        setDataPopupId(null);
        setTimeout(() => {
            setDataPopupId(dataId);
            setDataPopup(true);
        }, 100);
    }

    const dispatch = useDispatch();
    const handleShareCard = async (e, shareLink) => {
        e.preventDefault();
        try {
            if (navigator.share) {
                // Mobile sharing
                await navigator.share({
                    title: document.title,
                    url: shareLink
                });
                console.log('Thanks for sharing!');
            } else {
                // Desktop sharing - copy to clipboard
                await navigator.clipboard.writeText(shareLink);
                // You might want to show a toast or alert here
                alert('Link copied to clipboard!');
            }
        } catch (error) {
            console.error('Error sharing:', error);
        }
    };
   
    const { cardData } = useSelector((state) => state);
    const { data, error, isLoading, pagination } = cardData;


  
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));


    useEffect(() => {
        if (prevSearchTermRef.current !== searchTerm) {
            loadCards();
        }
        prevSearchTermRef.current = searchTerm;

        setHasLoaded(true);
        
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
        setCanShare(navigator.share ? true : false);

    }, [data, dispatch, searchTerm]);


    const loadCards = async () => {
        if(!hasLoaded) return;
        setLoading(true);
        let postData = {
            page   : 1,
            keyword: searchTerm,
        }
        await dispatch(retrieveCardsAction(postData));
        setLoading(false);
    }
    const loadMore = () => {
        const nextPage = pagination.page + 1;
        if (nextPage <= pagination.page_last) {
            setPageCount(nextPage);
            let postData = {
                page   : nextPage,
                keyword: searchTerm,
            }
            dispatch(retrieveCardsAction(postData));
        }
    };
    //remove Card item
    const MySwal = withReactContent(Swal)
    const handleDeleteCard = (id) => {
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden"; 
              },
              willClose: () => {
                document.body.style.overflow = ""; 
              }
        }).then((result) => {
            if (result.isConfirmed) {
               dispatch(DeleteCardAction(id));
              
            }
        });

    }
    return (
        <div className="card-container card-list-area">
            <div className="connection-header">
                <h3>Card Lists</h3>
                <div className="filter-wrapper">
                    <SearchForm
                        placeholder='Search card...'
                        loading={loading}
                        onChange={async (val) => {
                            setSearchTerm(val);
                        }}

                    />
                    <div className="list-filter">
                        <i className="ri-equalizer-line"></i>
                        <span>Filter</span>
                    </div>
                    <Link to="/card/new" className="list-filter add-new-btn">
                        <i className="ri-add-line"></i>
                        <span>Add New</span>
                    </Link>
                </div>
            </div>
            <div className="list-table connection-list">
                {data.length > 0 &&
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Company</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>

                            {data.map((item, index) => (
                                <tr key={item.ID}>
                                    <td>
                                        <div className="list-profile">
                                            {item.preview_photo ? (
                                                <ShimmerImage
                                                    src={item.preview_photo}
                                                    alt={item.card_name}
                                                    width={65}
                                                />
                                            ) : (
                                                <InitialAvatar
                                                    title={`${item.card_name}`}
                                                    size={65}
                                                />
                                            )}
                                            <span>{item.card_name}</span>
                                        </div>
                                    </td>
                                    <td>{item.card_company}</td>
                                    <td align='right'>
                                        <Link className="card-btn list-btn" to={`/card/${item.ID}`} onClick={(e) => {handleDataPopup(e, item.ID)}}>
                                            <i className="ri-eye-line"></i> View
                                        </Link>
                                        {canShare && (
                                        <Link className="icon-button list-btn" target='_blank' onClick={(e) => {handleShareCard(e, item.shareLink)}}>
                                           <i className="ri-share-forward-2-fill"></i>
                                        </Link>
                                        )}
                                        <button 
                                            className="share-button icon-button list-btn dropdown-toggle-btn"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleDropdown(index);
                                            }}
                                        >
                                            <i
                                                className="ri-more-2-fill"
                                            ></i>
                                        </button>
                                        <div className="list-edit-dropdown">
                                            {openDropdown === index && (
                                                <ul>
                                                    <li><Link to={`/card/settings/${item.ID}`}>Settings</Link></li>
                                                    <li><Link onClick={() => {
                                                        handleDeleteCard(item.ID);
                                                        setOpenDropdown(null);
                                                    }}>Delete</Link></li>
                                                </ul>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }

                {!isLoading && data && data.length === 0 &&
                    <NoContentFound title="No card found!" />
                }
                {isLoading &&
                    <>
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                    </>
                }
                {!isLoading && data && pagination.page_last > pagination.page && (
                    <div className="load-more-container">
                        <button 
                            className="load-more-btn" 
                            onClick={loadMore}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Loading...' : 'Load More'}
                        </button>
                    </div>
                )}
            </div>
            <DataModelPopup openModal={openDataPopup} setOpen={setDataPopup} sourceUrl={`/card/${dataPopupId}`} bodyData={<SingleCardData popupItemId={dataPopupId} onClose={handleCloseModal} />} />
        </div>
    );
}
export default CardListData;
